import type { UploadQuotaExceededDetail } from "@/lib/apiErrors";
import {
  publishGlobalApiError,
  subscribeGlobalApiError,
} from "@/lib/globalApiErrorBus";

export type UploadQuotaExceededEventDetail = UploadQuotaExceededDetail;

export const setUploadQuotaExceededListener = (
  listener: (detail: UploadQuotaExceededEventDetail) => void,
) => subscribeGlobalApiError("uploadQuotaExceeded", listener);

export const emitUploadQuotaExceeded = (
  detail: UploadQuotaExceededEventDetail,
) => {
  publishGlobalApiError("uploadQuotaExceeded", detail);
};
